export enum LoadingResource {
  Result = `result`,
  ApiResources = `apiResources`,
}

export enum ReportEditorActivePanel {
  QueryBuilder = `query`,
  ChartCustomization = `chart-customization`,
}

export enum BackToBoardSource {
  BackButton = `back_button`,
  EscapeKey = `escape_key`,
}

export type BackToBoardDetail = {
  source: BackToBoardSource;
};

export type BackToBoardEvent = CustomEvent<BackToBoardDetail>;
